import Auth from "./auth/reducer";
import App from "./app/reducer";
import Listings from "./CommonListing/reducer";
import AssessmentMaster from "./DashboardMaster/reducer";
import LanguageSwitcher from "./languageSwitcher/reducer";
import LocationMaster from "./LocationMaster/reducer";
import UserMaster from "./UserMaster/reducer";
import SVM from "./SystemValueMaster/reducer";
import ConsentPurpose from "./DashboardMaster/reducer";
import CompanyMaster from "./CompanyMaster/reducer";
import Contacts from "./ContactMaster/reducer";
import DataSub from "./DataSub/reducer";
import logoutFlag from "./Logout/reducer";
import RequestType from "./RequestType/reducer";
import RequestSources from "./RequestSources/reducer";
import RequestMaster from "./RequestMaster/reducer";
export default {
  Auth,
  App,
  Listings,
  LanguageSwitcher,
  LocationMaster,
  UserMaster,
  AssessmentMaster,
  SVM,
  ConsentPurpose,
  CompanyMaster,
  Contacts,
  DataSub,
  logoutFlag,
  RequestType,
  RequestSources,
  RequestMaster,
};
